// removed by extract-text-webpack-plugin
module.exports = {"intro-text":"_1uduB","introText":"_1uduB","title":"_9XEt5","text":"_2EkOH","footer":"_2yqPO","link-more":"_6MlH-","linkMore":"_6MlH-"};